import { getCookie as getCookieClient, useReactiveGetCookie } from 'cookies-next'
import { AUTH_COOKIE_AUTHENTICATION_MODE_KEY } from '@/feature/auth/services/auth.constant'

export function useIsImpersonating(): boolean {
  try {
    const getCookie = useReactiveGetCookie()

    return getCookie(AUTH_COOKIE_AUTHENTICATION_MODE_KEY) === 'impersonate'
  } catch {
    // Fallback for unit tests where CookieProvider is missing
    return getCookieClient(AUTH_COOKIE_AUTHENTICATION_MODE_KEY) === 'impersonate'
  }
}
